class a extends Error {
  constructor(r) {
    super(r), this.name = "LocalLogicTracking/ValidationError";
  }
}
export {
  a as ValidationError
};
